<template>
    <TemplateDetail
        v-if="entry"
        :entry
    />
</template>

<script setup>
import PageQuery from '~/graphql/queries/Entry.graphql';

defineI18nRoute({
    paths: {
        en: '/agenda/[slug]',
        nl: '/agenda/[slug]',
    },
});

const { variables: defaultVariables } = useCraftGraphql();

const variables = computed(() => {
    return {
        ...defaultVariables,
        section: 'agenda'
    };
});

const response = await useAsyncQuery({
    query: PageQuery,
    variables
});

const { craftEntry: entry } = useSeoCraftPage(response);

const generalStore = useGeneralStore();

generalStore.setPalette(`palette--${(entry?.value?.theme?.[0]?.slug || entry?.value?.neighbourhoodRelation?.[0]?.slug) ?? 'mma'}`);
</script>
